import Immutable from 'immutable';
import Cookies from 'js-cookie';
import { createStore, getActionIds } from '../helpers/redux';
import { AuthActions } from '../actions/auth';
import { userRoles } from '../helpers/access';

const actions = getActionIds(AuthActions);
// const userActions = getActionIds(UserActions);

const initialState = Immutable.fromJS({
  accessLvl: userRoles.public,
  error: null,
  user: {
    name: '',
    locale: {
      long: 'en-US', //'ja-JP',
      short: 'enUS', //'jaJP'
    },
  },
});

export const auth = createStore(initialState, {
  CLEAR_ACCESS_TOKEN: (state, action) => {
    // TODO: add this to the auth actions file
    return state.delete('accessToken');
  },

  [actions.moo]: (state, action) => {
    return state.merge({
      accessToken: 'abc',
    });
  },

  [actions.setAuthToken]: (state, action) => {
    return state.merge({
      accessToken: action.accessToken,
    });
  },

  [actions.logout]: (state, action) => {
    delete localStorage.accessToken;
    Cookies.remove('accessToken');

    return state.delete('accessToken');
  },

  [actions.authenticate.begin]: (state, action) => {
    return state.merge({
      error: null,
    });
  },

  [actions.authenticate.success]: (state, action) => {
    localStorage.accessToken = action.result.access_token;
    Cookies.set('accessToken', action.result.access_token);

    return state.merge({
      accessToken: action.result.access_token,
      error: null,
      accessLvl: userRoles.admin, //action.result.accessLvl
    });
  },

  [actions.authenticate.failure]: (state, action) => {
    return state.merge({
      error: 'Your username/email or password is incorrect.',
    });
  },

  [actions.getMe.begin]: (state, action) => {
    return state.merge({
      loaded: false,
      loading: true,
    });
  },

  [actions.getMe.success]: (state, action) => {
    return state.merge({
      accessLvl: action.result.entities.users[action.result.result].accessLvl,
      loaded: true,
      loading: false,
      user: action.result.result,
    });
  },

  [actions.getMe.failure]: (state, action) => {
    return state.merge({
      loaded: false,
      loading: false,
    });
  },
});

export const currentUserIdSelector = state => {
  return state.auth.get('user');
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js